import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { localizePath, useLang } from '../i18n';

const TEXT = {
    tr: {
        title: 'Sayfa Bulunamadı',
        heading: 'Sayfa bulunamadı',
        body: 'Aradığınız sayfa taşınmış veya kaldırılmış olabilir.',
        home: 'Ana Sayfaya Dön',
    },
    en: {
        title: 'Page Not Found',
        heading: 'Page not found',
        body: 'The page you are looking for may have been moved or removed.',
        home: 'Back to Home',
    },    de: {
        title: 'Seite nicht gefunden',
        heading: 'Seite nicht gefunden',
        body: 'Die gesuchte Seite wurde möglicherweise verschoben oder entfernt.',
        home: 'Zur Startseite',
    },
};

const NotFound = () => {
    const lang = useLang();
    const t = TEXT[lang];

    return (
        <Layout title={t.title}>
            <div className="container mx-auto px-4 py-24 text-center">
                <p className="text-6xl font-bold text-blue-600 mb-4">404</p>
                <h1 className="text-3xl font-bold text-gray-900 mt-0 mb-4">{t.heading}</h1>
                <p className="text-lg text-gray-600 mb-8">{t.body}</p>
                <Link to={localizePath('/', lang)} className="inline-block px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white hover:text-white font-semibold rounded-lg transition duration-300">
                    {t.home}
                </Link>
            </div>
        </Layout>
    );
};

export default NotFound;
